import { api } from './base';

import { MutationArg } from 'v2/types';
import { DailyRewardModel } from 'v2/types/DailyRewardModel';

interface UpdateDailyRewardArg {
  dailyRewardId: string;
  payload: Omit<DailyRewardModel, 'id'>;
}

export const dailyRewardsService = {
  getDailyRewards(): Promise<DailyRewardModel[]> {
    return api.get('admin/user-daily-reward').json();
  },

  createDailyReward(_key: string, { arg }: MutationArg<Omit<DailyRewardModel, 'id'>>): Promise<DailyRewardModel> {
    return api.post('admin/user-daily-reward', { json: arg }).json();
  },

  updateDailyReward(_key: string, { arg }: MutationArg<UpdateDailyRewardArg>): Promise<DailyRewardModel> {
    return api.put(`admin/user-daily-reward/${arg.dailyRewardId}`, { json: arg.payload }).json();
  },

  deleteDailyReward(_key: string, { arg: dailyRewardId }: MutationArg<string>): Promise<void> {
    return api.delete(`admin/user-daily-reward/${dailyRewardId}`).json();
  },
};
